








































import Vue from "vue";
import StandartCard from "@/components/Card/StandartCard/StandartCard.vue";
import LineChart from "@/components/Chart/LineChart.vue";
import { CameraImage } from "@/store/modules/CameraImage/interface";
import Utils from "@/utils/utils";

export default Vue.extend({
  name: "DeviceVehicleCard",
  components: { StandartCard, LineChart },
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    datas: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    styles: {
      type: Object,
      default: () => ({ height: "300px" })
    },
    no_title: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      datacollection: {}
    };
  },
  mounted(): void {
    this.fillData();
  },
  methods: {
    fillData() {
      this.datacollection = {
        labels: this.labels,
        datasets: this.format_data_dataset
      };
    },
    datas_per_day(attr: string): Array<number> {
      const datas_per_day: any = {};
      (this.datas as Array<CameraImage>).forEach((data) => {
        const label = Utils.transformDateToYMD(data.d_h_process);
        if (datas_per_day[label] === undefined) datas_per_day[label] = 0;
        datas_per_day[label] += data[attr as keyof CameraImage] as number;
      });
      return Object.values(datas_per_day);
    },
    datas_per_hours(attr: string): Array<number> {
      return (this.datas as Array<CameraImage>).map((data) => data[attr as keyof CameraImage] as number);
    }
  },
  computed: {
    format_data_dataset(): Array<any> {
      const dataset: Array<any> = [];
      dataset.push({
        label: "Nombre de véhicule",
        data: this.type === "hours" ? this.datas_per_hours("nb_jpg") : this.datas_per_day("nb_jpg"),
        borderColor: "#6caf8f",
        borderWidth: 1,
        fill: false
      });
      dataset.push({
        label: "Nombre de véhicule inconnu",
        data: this.type === "hours" ? this.datas_per_hours("nb_unknown") : this.datas_per_day("nb_unknown"),
        borderColor: "#bc5265",
        borderWidth: 1,
        fill: false
      });
      return dataset;
    }
  },
  watch: {
    labels: {
      handler(): void {
        this.fillData();
      }
    }
  }
});
